import { getJwtTools } from "@/components/authentication/utils";
import { getBaseThemeName } from "@/features/branding";
import { useEffect, useState } from "react";

export const useCreatablePortfolioTypes = () => {
  const [creatablePortfolioTypes, setCreatablePortfolioTypes] = useState<string[]>([]);
  useEffect(() => {
    getJwtTools().then((tools) => {
      const creatable = tools?.comprehensive?.portfolioInsights?.creatablePortfolioTypes;
      if (creatable) {
        setCreatablePortfolioTypes(creatable);
        return;
      }
      // Backwards compatibility: fall back to availablePortfolioTypes
      const available = tools?.comprehensive?.portfolioInsights?.availablePortfolioTypes;
      if (available && available.length > 0) {
        setCreatablePortfolioTypes(available);
        return;
      }

      // Final fallback
      setCreatablePortfolioTypes(getBaseThemeName() === "hkma" ? ["hk"] : ["global"]);
    });
  }, []);
  return creatablePortfolioTypes;
};
